export default "__VITE_ASSET__95e43b88__"